import { CTA_LINKS } from '@/config/routes';

export function openCalcom() {
  // Ouvre la page de réservation Cal.com dans un nouvel onglet
  window.open(CTA_LINKS.calcom, '_blank');
}

export function openWhatsApp() {
  // 1) tente d'ouvrir le widget existant
  // (ex. GetButton/Crisp/Tidio – adapter aux globals si présents)
  if ((window as any)?.WhWidgetSendButton?.open) { 
    (window as any).WhWidgetSendButton.open(); 
    return; 
  }
  if ((window as any)?.$crisp) { 
    (window as any).$crisp.push(["do", "chat:open"]); 
    return; 
  }
  if ((window as any)?.tidioChatApi?.open) { 
    (window as any).tidioChatApi.open(); 
    return; 
  }

  // 2) fallback wa.me (numéro FR +33 7 56 86 09 93)
  window.open('https://wa.me/33756860993?text=Bonjour%20Cosmos%20Wave%2C%20je%20souhaite%20un%20audit%20Amazon.', '_blank');
}

export function resolveCta(hrefKey: string) {
  if (hrefKey === 'whatsapp') return 'javascript:;';
  if (hrefKey === 'calcom') return 'javascript:;';
  return CTA_LINKS[hrefKey as keyof typeof CTA_LINKS] || '#';
}

export function handleCtaClick(hrefKey: string, e: React.MouseEvent) {
  if (hrefKey === 'whatsapp') { 
    e.preventDefault(); 
    openWhatsApp(); 
    return;
  }
  // Pour tous les autres CTAs, rediriger vers la route configurée
  const href = resolveCta(hrefKey);
  if (href !== 'javascript:;' && href !== '#') {
    window.location.href = href;
  }
}

export function useCta() {
  return {
    openWhatsApp,
    openCalcom,
    resolveCta,
    handleCtaClick
  };
}